import './style.less';
import Papa from 'papaparse';

export default function($q, $log) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  vm.uploadFile = file => {
    if (!file) {
      return;
    }

    vm.uploadBtn = true;

    papaPromise(file).then(
      data => {
        const cleanData = (vm.columns
          ? data.map(ele => {
              return vm.columns.reduce((acc, col) => {
                acc[col] = findField(ele, col);

                return acc;
              }, {});
            })
          : data
        ).filter(ele => notExampleData(ele, vm.columns, vm.exampleFileData));

        vm.action({ data: cleanData });
        vm.uploadBtn = false;
      },
      err => {
        $log.error(err);
      }
    );
  };

  /**
   * Returns the prop on the object, or finds a prop that contains the prop name, or returns undefined.
   *
   * @param {*} obj
   * @param {*} officialColName
   */
  function findField(obj, officialColName) {
    return (
      obj[officialColName] ||
      obj[
        Object.keys(obj).find(colNameInFile => colNameInFile.toLowerCase().indexOf(officialColName.toLowerCase()) > -1)
      ]
    );
  }

  /**
   * Takes a data element and all the example rows, and verifies that the element is not example data
   *
   * @param {*} ele
   * @param {*} cols
   * @param {*} exampleRows
   */
  function notExampleData(ele, cols, exampleRows) {
    if (!cols || cols.length === 0 || !exampleRows || exampleRows.length === 0) {
      return true;
    }

    return !exampleRows.find(exampleRow => matchesExampleRow(ele, cols, exampleRow));
  }

  /**
   * Takes a data element and a row of example data, and returns true if they match
   *
   * @param {*} ele
   * @param {*} cols
   * @param {*} exampleData
   */
  function matchesExampleRow(ele, cols, exampleData) {
    return !cols.find((col, index) => ele[col] !== exampleData[index]);
  }

  /**
   * Wraps PapaParse in a promise
   *
   * @param {*} file
   */
  function papaPromise(file) {
    return $q((resolve, reject) => {
      Papa.parse(file, {
        complete: ({ data }) => resolve(data),
        error: err => reject(err),
        header: true
      });
    });
  }

  function activate() {
    if (!vm.action) {
      throw new Error('Missing action for csv parse component');
    }

    vm.ngfAccept = 'text/csv';
    vm.fileName = `${vm.exampleFileName || 'example'}.csv`;

    const colList = (vm.columns || [])
      .map((col, index, arr) => `${index === arr.length - 1 && vm.columns.length > 1 ? 'and ' : ''}'${col}'`)
      .join(', ');
    vm.columnText = `The CSV should have the column header${vm.columns.length > 1 ? 's' : ''}: ${colList}.`;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/csvParse/controller.js